import { render, staticRenderFns } from "./ProfileAiData.vue?vue&type=template&id=4eee63ba&scoped=true&"
import script from "./ProfileAiData.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileAiData.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee63ba",
  null
  
)

export default component.exports